import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';

export default data => {
  return data.hb2Banners ? data.hb2Banners.map(item => {
    return {
      title: get(item, 'hb2Title', null),
      subtext: get(item, 'hb2Subtext', null),
      image: get(item, 'hb2Image', null) ? refactorRespImg(get(item, 'hb2Image', null), [{
        size: 'default',
        key: 'image_size_840x570', 
      },{
        size: 'md',
        key: 'image_size_1600x650',
      }]): null,
      videos: get(item, 'hb2VideoDesktop.guid', null) ? {
        desktopVideo: get(item, 'hb2VideoDesktop.guid', null),
        mobileVideo: get(item, 'hb2VideoMobile.guid', null),
      }: null,
      link: {
        'title': get(item, 'hb2Link.title', null),
        'href': get(item, 'hb2Link.url', null),
        'tagret': get(item, 'hb2Link.target', null),
        "assignedDomains": [
          "jayco.com.au",
          "jayco.co.nz",
          "AU-dealers",
          "NZ-dealers"
        ]
      },
    }
  }) : null
}
